// frontend/src/pages/learning/Booking.jsx
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import './ThinkService.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';


const ThinkRentMyBookings = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const location = useLocation();
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);

    const [myBookings, setMyBookings] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedBookingId, setSelectedBookingId] = useState([]);
    const [showImage, setShowImage] = useState(false);

    
    const buttonStyle = {
      marginLeft: '10px',
      padding: '5px 10px',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#25D366',
      color: '#fff'
    };

    const button1Style = {
      margin: '10px',
      padding: '10px',
      fontSize: '16px',
    };

    const fetchMyBookings = useCallback(() => {
      const config = { 
        url: "/rentalbooking/mybookinglist", 
        method: "post", 
        headers: { Authorization: authState.token },
        data: {userId: userId}
      };
      // console.log("BookingFlow Config: ",config)
  
      fetchData(config, { showSuccessToast: false })
      .then(({ bookings }) => setMyBookings(bookings))
      .catch(error => console.error("Error fetching data:", error));
  
      }, [authState.token, fetchData]);
  
    useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyBookings();
    }, [authState.isLoggedIn, fetchMyBookings]);
  
    const sortedMyBookings = [...myBookings].sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
  
    const handleBookingView = (_id) => {
      setSelectedBookingId(prevId => (prevId === _id ? null : _id));
    };

    // Call method
    const handleCallClick = (contactNumber) => {
      window.location.href = `tel:${contactNumber}`;
    };
  
    // WhatsApp method
    const handleWhatsAppClick = (contactNumber) => {
      const whatsappUrl = `https://wa.me/${contactNumber}`;
      window.open(whatsappUrl, '_blank');
    };
  
    // Email method
    const handleEmailClick = (contactEmail) => {
        window.location.href = `mailto:${contactEmail}`;
    };
    
    const handleItineraryClick = () => {
      setShowItineraryClicked(prevState => !prevState);
    };
  
    const formatDateTime = (date) => {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

  const handleShowImage = () => {
    setShowImage(!showImage);
  };


  return (
    <MainLayout>
    <div className="my-1 mx-auto py-1 min-w-full">
        <div className="text-white">
            <div className="my-2 mx-auto py-4">
                {myBookings.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>({myBookings.length}) Bookings</h2>}
                {loading ? (
                <Loader />
                ) : (
                <div className="flex flex-col text-purple-500 text-m">
                    {myBookings.length === 0 ? (
                    <div className='mt-4 my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>Currently there is no Bookings!!</div>
                    ) : (
                    sortedMyBookings.map((booking, index) => (
                        <div key={booking._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md mt-4'>
                        <div className='flex flex-row mt-4'>
                            <span>{index + 1}. </span> {booking.title}
                            <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleBookingView(booking._id)}>
                                <i className="fa-solid fa-eye"></i>
                            </span>
                            </Tooltip>
                        </div>
                        {selectedBookingId === booking._id && (
                            <div className='bg-gray-200 text-black mt-2'>
                            <p className='text-blue-500 mt-2'>{booking.title}</p>
                            <p className='mt-2'>{booking.objective}</p>
                            <p className='mt-2'><strong>Date:</strong> {formatDateTime(booking.fromDate)}<strong> To</strong> {formatDateTime(booking.toDate)}</p>
                            <p className='mt-2'><strong>Timing:</strong>{booking.timing}</p>
                            <p className='mt-2'><strong>Venue:</strong>{booking.venue}</p>
                            <p className='mt-2'><strong>Organiser:</strong>{booking.organiserName}</p>
                            <p className='mt-2'><strong>Remarks:</strong> <span dangerouslySetInnerHTML={{ __html: booking.remarks }} /></p>
                            <p className='mt-2'><strong>Fee:</strong>{booking.feeDetails}</p>
                            <button onClick={handleShowImage}>
                              <FontAwesomeIcon icon={faImage} /> View Image
                            </button>
                            {showImage && (
                              <div>
                                <img 
                                  src={`/api/downloads/bookings/images/${booking.bookingCode}.png`}
                                  alt="Booking Invitation" 
                                  style={{ maxWidth: '100%', height: 'auto' }} 
                                />
                              </div>
                            )}

                            <p className='mt-2'><strong>Current Status:</strong>{booking.currentStatus}</p>
                            <p><strong>Enroll Now:</strong>{booking.enrollNow ? "Yes" : "No"}</p>
                            <p><strong>Payment Method:</strong>{booking.paymentMethod}</p>
                            <p><strong>Contact Person / Organisor: </strong> {booking.contactPerson}</p>
                            <p>
                                <button onClick={() => handleCallClick(booking.contactNumber)} style={buttonStyle}>
                                📞 Call
                                </button>
                                <button onClick={() => handleWhatsAppClick(booking.contactNumber)} style={buttonStyle}>
                                💬 WhatsApp
                                </button>
                                <button onClick={() => handleEmailClick(booking.contactEmail)} style={buttonStyle}>
                                    ✉️ Email
                                </button>
                            </p>
                            </div>
                        )}
                        </div>
                    ))
                    )}
                </div>
                )}
            </div>
        </div>
    </div>
    </MainLayout>
  );
};

export default ThinkRentMyBookings;
